import { render, staticRenderFns } from "./FilterMenu.vue?vue&type=template&id=b3bb7c84&scoped=true&"
import script from "./FilterMenu.vue?vue&type=script&lang=js&"
export * from "./FilterMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3bb7c84",
  null
  
)

export default component.exports